import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { formatPrice } from "../../helpers";
import { appSetToggle, setConfirm } from "../../store/actions/appAction";
import { apiDeleteFinancial, apiGetFinancials } from "../../api/financialApi";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import IconEdit from "../../assets/svg/pen-icon-account.svg";
import IconKey from "../../assets/svg/icon-key-account.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";
import plusIcon from "../../assets/svg/plus-table.svg";
import bankLogo from "../../assets/svg/bank-card-background.svg";
import cashierBackground from "../../assets/svg/cashier-card-background.svg";
import logoCahsier from "../../assets/svg/cashier-card-logo.svg";
import logoBank from "../../assets/svg/bank-card-logo.svg";
import posImg from "../../assets/svg/pos.svg";
import fundBackground from "../../assets/svg/fund-card-background.svg";
import logoFund from "../../assets/svg/fund-card-logo.svg";
import "../../assets/styles/financials/financials.scss";
import { apiDeletePos, apiGetPos } from "api/PosApi";
import { Typography } from "@mui/material";

export default function Financials() {
    const tabs = [
        { key: "all", title: "همه" },
        { key: "bank", title: "بانک" },
        { key: "fund", title: "تنخواه گردان" },
        { key: "cashier", title: "صندوق" },
         { key: "posSetting", title: " کارت خوان" },
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const renderTabType = location.state?.type;

    const financialsState = useSelector((state) => state).financialReducer;
    const toggle = useSelector((state) => state.appReducer.toggle);
    const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
    const token = useSelector((state) => state).businessReducer.business?.token;

    const defaultTab = tabs.find((t) => t.key === (renderTabType ?? tabs[0].key));
    const [activeTab, setActiveTab] = useState(defaultTab);
    const [financials, setFinancials] = useState([]);
    const [showFinancialActions, setShowFinancialActions] = useState(null);

    // useEffect(() => {
    //     dispatch(resetFormState());
    //     fetchFinancials();
    // }, []);

    useEffect(() => {
        setFinancials([]);
        fetchFinancials();
    }, [activeTab, sendingRequest]);

    useEffect(() => {
        let financials = [];
        if (activeTab.key === "all") {
            financials = [...financialsState.banks, ...financialsState.funds, ...financialsState.cashiers];
        } else if (activeTab.key === "posSetting") {

        } else {
            financials = financialsState[`${activeTab.key}s`];
        }

        setFinancials(financials);
    }, [financialsState]);

    useEffect(() => {
        if (!toggle) setShowFinancialActions(toggle);
    }, [toggle]);

    const fetchFinancials = () => {
        if (activeTab.key === "all") {
            dispatch(apiGetFinancials("bank", token));
            dispatch(apiGetFinancials("fund", token));
            dispatch(apiGetFinancials("cashier", token));
        } else if (activeTab.key === "posSetting") {
            dispatch(apiGetPos(token, (res) => {
                setFinancials(res.data.pos);
            })
            )
        } else {
            dispatch(apiGetFinancials(activeTab.key, token));

        }
    };

    const toggleShowFinancialActions = (id) => {
        dispatch(appSetToggle(showFinancialActions !== id));
        setShowFinancialActions(showFinancialActions === id ? null : id);
    };

    return (
        <div className="wrap-financials">
            <div className="header-financials">
                <div className="header-right">
                    <div>حساب ها</div>
                    <div>لیست بانک ها، تنخواه گردان ها و صندوق ها</div>
                </div>
                <div className="header-left">
                    <button className="btn-add">
                        <a
                            href="financials/add"
                            onClick={(e) => {
                                navigate(activeTab.key === "posSetting" ? "/financials/addPos" : "/financials/add", {
                                    state: {
                                        type: activeTab.key,
                                    },
                                });
                                e.preventDefault();
                            }}
                        >
                            <img src={plusIcon} alt="plusIcon" />
                            افزودن
                        </a>
                    </button>
                </div>
            </div>
            <div className="tabs-cards">
                {tabs.map((tab, index) => (
                    <RenderTab key={index} tab={tab} active={activeTab.key === tab.key} setActiveTab={setActiveTab} />
                ))}
            </div>
            <div className="body-cards row">

                {financials.map((financial, index) => {
                    if (activeTab.key === "posSetting") {
                        return <PosCard key={index} fetchFinancials={fetchFinancials} toggleShowFinancialActions={toggleShowFinancialActions} data={financial} active={toggle && showFinancialActions === financial.id} />
                    } else {

                        return (
                            <FinancialCard
                                key={index}
                                financial={financial}
                                active={toggle && showFinancialActions === financial.id}
                                toggleShowFinancialActions={toggleShowFinancialActions}
                            />
                        )
                    }
                })}
            </div>
        </div>
    );
}

const RenderTab = ({ tab, active, setActiveTab }) => {
    return (
        <div
            className={active ? "active-tab-item-card" : "tab-item-card"}
            onClick={() => {
                setActiveTab(tab);
            }}
        >
            {tab.title}
        </div>
    );
};

const FinancialCard = ({ financial, active, toggleShowFinancialActions }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector((state) => state).businessReducer.business.token;
    const secretView = useSelector((state) => state.appReducer.secretView);

    const deleteFinancial = (id, type) => {
        dispatch(setConfirm("حساب", () => dispatch(apiDeleteFinancial(id, type, token))));
    };

    return (
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card">
            <div className="card-box">
                <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
                    <a
                        href={`/financials/${financial.id}`}
                        onClick={(e) => {
                            navigate(`/financials/${financial.id}`);
                            e.preventDefault();
                        }}
                    >
                        <img src={IconEdit} alt="IconEdit" />
                        ویرایش
                    </a>
                    <div onClick={() => deleteFinancial(financial.id, financial.type)}>
                        <img src={IconDelete} alt="IconEdit" />
                        حذف حساب
                    </div>
                </div>
                {financial.type === "bank" ? (
                    <img className="logo-original" src={bankLogo} alt="original-logo" />
                ) : financial.type === "fund" ? (
                    <img className="logo-original" src={fundBackground} alt="original-logo" />
                ) : financial.type === "cashier" ? (
                    <img className="logo-original" src={cashierBackground} alt="original-logo" />
                ) : null}
                <div className="header-card">
                    <div className="right-header-card">
                        <div />
                        <div />
                        <div className="logo-card">
                            {financial.type === "bank" ? (
                                <img src={logoBank} alt="logo-bank" />
                            ) : financial.type === "cashier" ? (
                                <img src={logoCahsier} alt="logoCahsier" />
                            ) : financial.type === "fund" ? (
                                <img src={logoFund} alt="logoFund" />
                            ) : null}
                        </div>
                    </div>
                    <div className="left-header-card">
                        <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowFinancialActions(financial.id)} />
                    </div>
                </div>
                <div className="title-card-box">
                    <a
                        href={`/reports/${financial.type}Transactions?${financial.type}Id=${financial.id}`}
                        onClick={(e) => {
                            navigate(`/reports/${financial.type}Transactions?${financial.type}Id=${financial.id}`);
                            e.preventDefault();
                        }}
                    >
                        {secretView ? "********" : `${financial.accountingCode} - ${financial.name}`}
                    </a>
                </div>
                <p className="text-number-card">{secretView ? "********" : financial.accountNumber}</p>
                <div className="branch-card">
                    {financial.branch != null ? (
                        <>
                            <img src={IconKey} alt="IconKey" />
                            <div className="name-branch">{secretView ? "********" : financial.branch}</div>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="line-card" />
                <div className="footer-card">
                    <span>موجودی:</span>
                    <b>{secretView ? "********" : formatPrice(financial?.balance || 0)}</b>
                    <span>{secretView ? "********" : financial.Currency?.en_title}</span>
                </div>
            </div>
        </div>
    );
};
const PosCard = ({ data, active, toggleShowFinancialActions ,fetchFinancials }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector((state) => state).businessReducer.business.token;
    const secretView = useSelector((state) => state.appReducer.secretView);

    const deleteFinancial = (id, type) => {
        dispatch(setConfirm("کارت خوان", () => dispatch(apiDeletePos(id, token,(res)=>{
            fetchFinancials()
        }
        ))));
    };
    return <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card">
        <div className="card-box">
            <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
                <a
                    href={`/financials/addPos/${data.id}`}
                    onClick={(e) => {
                        navigate(`/financials/addPos/${data.id}`);
                        e.preventDefault();
                    }}
                >
                    <img src={IconEdit} alt="IconEdit" />
                    ویرایش
                </a>
                <div onClick={() => deleteFinancial(data.id, data.type)}>
                    <img src={IconDelete} alt="IconEdit" />
                    حذف کارتخوان
                </div>
            </div>

            <img className="logo-original" src={bankLogo} alt="original-logo" />

            <div className="header-card">
                <div className="right-header-card">
                    <div />
                    <div />
                    <div className="logo-card">

                        <img src={posImg} alt="logo-bank" />

                    </div>
                </div>
                <div className="left-header-card">
                    <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowFinancialActions(data.id)} />
                </div>
            </div>
            <div className="title-card-box flex flex-col">
                <Typography variant="body1" className="text-gray-950 font-bold">{data.title}</Typography>
                <a
                    className="text-gray-500 text-wrap"
                    href={`/reports/${data.type}Transactions?${data.type}Id=${data.id}`}
                    onClick={(e) => {
                        navigate(`/reports/${data.type}Transactions?${data.type}Id=${data.id}`);
                        e.preventDefault();
                    }}
                >
                    {secretView ? "********" : `متصل به حساب  ${data?.Financial?.name}`}
                </a>
            </div>
            <p className="text-number-card">{secretView ? "********" : data.accountNumber}</p>
            <div className="branch-card">
                {data.branch != null ? (
                    <>
                        <img src={IconKey} alt="IconKey" />
                        <div className="name-branch">{secretView ? "********" : data.branch}</div>
                    </>
                ) : (
                    <></>
                )}
            </div>
            <div className="line-card" />
            <div className="footer-card h-9">
                <span>آدرس IP:</span>
                <b>{secretView ? "********" : data?.ip }</b>
            </div>
        </div>
    </div>

}